<template>
  <div class="inline-keyboard-item keyboard-item action-item shadow">
    <BasicInput v-model="item.text" placeholder="Text" class="half-input" />
    <BasicInput v-model="item.callback_data" placeholder="Action" class="half-input"/>
    <span @click="deleteItem"><Trash  /></span>
  </div>
</template>

<script>
import Trash from '@/components/icons/Trash'
import BasicInput from '@/components/inputs/BasicInput'

export default {
  props: ['index', 'item'],
  components: {BasicInput, Trash},
  methods: {
    deleteItem() {
      this.$emit('deleteItem', this.index)
    }
  }
}
</script>

<style lang="scss">
.action-item {
  width: 100%;
  margin: 6px 0;
  background-color: #2f3b4d;
  padding: 8px 10px;
  border-radius: 2px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;

  &.shadow {
      box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
      &:hover {
        box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
      }
      &:active {
        box-shadow: 0 0px 0px rgba(0,0,0,0.16), 0 0px 0px rgba(0,0,0,0.23);
      }
    }

  .half-input {
    width: 100%;
    margin-right: 6px;
    font-size: 13px;
    background: transparent;
    border: none;
    padding: 4px 0 4px 0; 
    border-radius: 0;
    border-bottom: 1px solid rgba($color: #fff, $alpha: 0.05);
    &:hover {
      border-bottom: 1px solid rgba($color: #fff, $alpha: 0.75);  
    }

    &:focus {
      border-bottom: 1px solid rgba($color: #fff, $alpha: 1);
    }
  }
}
</style>